export function getTransportModeIcon(transportMode: string): string {
  switch (transportMode) {
    case 'car':
      return 'driving'
    case 'pedestrian':
      return 'walking'
    default:
      return ''
  }
}

export function getTransportModeChipColor(transportMode: string): string {
  switch (transportMode) {
    case 'car':
      return 'var(--hds-action)'
    case 'pedestrian':
      return 'var(--hds-aqua-onlight-500)'
    default:
      return ''
  }
}

export function getContrastForegroundColor(
  inputHex: string
): 'var(--hds-onlightcolor-primary)' | 'var(--hds-ondarkcolor-primary)' {
  const hexColor = inputHex[0] === '#' ? inputHex.substring(1) : inputHex
  if (hexColor.length !== 3 && hexColor.length !== 6) return 'var(--hds-ondarkcolor-primary)'

  const isShortHex = hexColor.length === 3

  const r = parseInt(isShortHex ? hexColor[0] : hexColor.substring(0, 2), 16)
  const g = parseInt(isShortHex ? hexColor[1] : hexColor.substring(2, 4), 16)
  const b = parseInt(isShortHex ? hexColor[2] : hexColor.substring(4, 6), 16)

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / (isShortHex ? 15 : 255)
  return luminance > 0.55 ? 'var(--hds-onlightcolor-primary)' : 'var(--hds-ondarkcolor-primary)'
}

// Check if the color is White
export const isWhite = (color: string): boolean =>
  color.toUpperCase() === '#FFFFFF' ||
  color.toUpperCase() === '#FFF' ||
  color.toUpperCase() === 'WHITE'
